import { render, staticRenderFns } from "./SunView.vue?vue&type=template&id=af2f0e24"
import script from "./SunView.vue?vue&type=script&lang=js"
export * from "./SunView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports